import type { PhoneNumber } from 'apis/numbers';
import { GetNumbersByQueryPayloadT } from 'components/telephony/api/types';

import { ajaxSend } from '../../../api/api';

const BASE_PATH = '/v1/numbers';
const AVAILABLE_NUMBERS_PATH = '/v1/available-numbers';

export const getAllNumbers = () =>
  ajaxSend({
    path: `${BASE_PATH}?limit=100`,
  });

export const getNumbersByQuery = (payload: GetNumbersByQueryPayloadT) => {
  const { query } = payload;
  const isPathParameterPassed = !!query.path;
  const params = new URLSearchParams();

  if (!isPathParameterPassed) {
    const { limit, count, after, before, search } = query;

    params.set('limit', limit ?? '12');

    if (count) {
      params.set('count', count);
    }

    if (after) {
      params.set('after', encodeURIComponent(after));
    }

    if (before) {
      params.set('before', encodeURIComponent(before));
    }

    if (search) {
      params.set('search', search);
    }
  }

  return ajaxSend({
    path: query.path ?? `${BASE_PATH}?${params.toString()}`,
  });
};

export const releaseNumber = (number: PhoneNumber) =>
  ajaxSend({
    path: `${BASE_PATH}/${number.e164_format}`,
    method: 'DELETE',
  });

export const searchNumbers = (payload: any) => {
  const {
    selectedCountry: { country_code },
    numType,
    page,
    next_page,
    prev_page,
  } = payload;
  const params = new URLSearchParams();
  const request = { path: '' };

  if (page) {
    params.set('page', page);
  }

  if (numType) {
    params.set('numbers_type', numType);
  }

  if (next_page) {
    request.path = next_page;
  } else if (prev_page) {
    request.path = prev_page;
  } else {
    request.path = `${AVAILABLE_NUMBERS_PATH}/${country_code.toUpperCase()}?${params.toString()}`;
  }

  return ajaxSend(request);
};

export const buyNumber = (payload: any) => {
  const { number, name } = payload;

  return ajaxSend({
    path: BASE_PATH,
    method: 'POST',
    data: {
      phone_number: {
        e164_format: number.e164_format,
      },
      name: name,
    },
  });
};

export const buyGroup = (payload: any) => {
  const { group, name } = payload;

  return ajaxSend({
    path: BASE_PATH,
    method: 'POST',
    data: {
      group: {
        group_id: group.group_id,
      },
      name: name,
    },
  });
};

export const updateNumber = (payload: {
  number: string;
  name: string;
  record_outbound_calls: boolean;
}) => {
  const { number, name, record_outbound_calls } = payload;
  return ajaxSend({
    path: `${BASE_PATH}/${number}`,
    method: 'PUT',
    data: {
      name: name,
      record_outbound_calls: record_outbound_calls,
    },
  });
};

export const verifyExternalCallerId = (payload: any) => {
  const data = {
    e164_format: payload.phone_number,
    extension: payload.extension,
    name: payload.name,
  };

  return ajaxSend({
    path: `${BASE_PATH}/outgoing-verification`,
    method: 'PUT',
    data: data,
  });
};
